import React, { Component } from "react";
import "./EasyMode.scss";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import AddAccount from "../addAccount/AddAccount.js";
import CountryDropDown from "../utils/countryDropDown/CountryDropDown";
import QueryResults from "../queryResults/QueryResults";
import { ReactComponent as AddIcon } from "../../../../../assets/svg/queryplus-icon.svg";
import { ReactComponent as CaneclIcon } from "../../../../../assets/svg/close.svg";
import {
    searchQueryResults,
    fetchProgressBarInfo,
    resetPostContainer,
    getAllSupportedLanguages,
    googleTextTranslate,
    setLocation,
    setBoolean,
    setKeywordTypeValue,
    setShowSample,
    setKeywordExpandBlock,
    setAccountExpandBlock,
    setValidRule,
    toggleSampleButton,
} from "../../../../../actions/queryBuilderActions";
import { Scrollbars } from "react-custom-scrollbars";
import Select from "react-select";
import PlatformWiseAnalysis from "../platformWiseAnalysisChart/PlatformWiseAnalysis";
import { ReactComponent as TranslateHeaderIcon } from "../../../../../assets/svg/translate-header.svg";
import { ReactComponent as ExpandIcon } from "../../../../../assets/svg/chevron.svg";
import { ReactComponent as ExpandViewIcon } from "../../../../../assets/svg/expand-icon.svg";
import { ReactComponent as CollapseViewIcon } from "../../../../../assets/svg/collapse-icon.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { ReactComponent as ProgressIcon } from "../../../../../assets/svg/progress-completed.svg";
import { ReactComponent as FieldAddIcon } from "../../../../../assets/svg/add.svg";
import { ReactComponent as InfoIcon } from "../../../../../assets/svg/info-icon.svg";
import ConfigureKeywords from "./ConfigureKeywords";
import { isMobile } from "react-device-detect";

export const langOptionsCalculations = (supportedLanguages) => {
    // const supportedLanguages = this.props.allSupportedLanguages;
    let newLangList = [];
    supportedLanguages.forEach((ele) => {
        let newObj = Object.assign({}, ele, { label: ele.name, value: ele.code });
        newLangList.push(newObj);
    });
    return newLangList;
};

export const handleQueryBuilder = (keywordTypelist) => {
    let keywordList = keywordTypelist.filter((ele) => ele.keyword !== "");
    let list = keywordList.map((ele) => {
        if (ele.keyword.startsWith(`"`) && ele.keyword.endsWith(`"`)) return ele.keyword;
        else return JSON.stringify(ele.keyword);
    });
    let translatedList = [];
    keywordTypelist.forEach((ele) => {
        let acc = [];
        acc = ele.translateOptionsList.filter((item) => {
            return item.addedText !== "";
        });
        if (acc.length > 0) {
            translatedList.push(...acc);
        }
    });
    let translateList = translatedList.map((ele) => {
        return JSON.stringify(ele.translatedText);
    });
    let singleList = [...list, ...translateList].join(",");
    let listModified = singleList.replace(/,/g, " OR ");
    if (keywordList.length === 0) {
        listModified = "";
    }
    return listModified;
};
export const random = (min = 1, max = 1000000) => Math.floor(Math.random() * (max - min)) + min;

export const addKeywordsField = (args, dispatchFn) => {
    let inputId = random();
    let newKeywords = [
        ...args,
        {
            keyword: "",
            enable: false,
            id: inputId,
            translateOptionsList: [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }],
        },
    ];
    dispatchFn(newKeywords, "keywords");
    !isMobile &&
        setTimeout(() => {
            document.getElementById(inputId).focus();
        }, 300);
};
export const addGenericField = (args, dispatchFn) => {
    let inputId = random();
    let newGenericKeyword = [
        ...args,
        {
            keyword: "",
            enable: false,
            id: inputId,
            translateOptionsList: [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }],
        },
    ];
    dispatchFn(newGenericKeyword, "genericKeyword");
    setTimeout(() => {
        document.getElementById(inputId).focus();
    }, 300);
};
export const addExcludedField = (args, dispatchFn) => {
    let inputId = random();
    let newExcludedKeyword = [
        ...args,
        {
            keyword: "",
            enable: false,
            id: inputId,
            translateOptionsList: [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }],
        },
    ];
    dispatchFn(newExcludedKeyword, "excludedKeyword");
    setTimeout(() => {
        document.getElementById(inputId).focus();
    }, 300);
};

const allReplace = (str) => {
    return str.replace(/[`~!@#$%^&*_|+\-=?;:',.<>{}[\]\\/]/g, "");
};
const validateCharacters = (boolVal) => {
    let len = boolVal.length;
    for (var i = 0; i < len; i++) {
        if (boolVal.charCodeAt(i) >= 127 && boolVal.charCodeAt(i) <= 160) {
            return i;
        }
    }
    return 0;
};

export const validateBooleans = (bool) => {
    if (validateCharacters(bool) != 0) {
        toast.error("Invalid Characters in Boolean");
        return false;
    }

    if (bool.length < 3) {
        toast.error("Boolean length should atleast be 3 characters long.");
        return false;
    }

    let nonspecial = allReplace(bool);
    if (nonspecial == "") {
        toast.error("Invalid Boolean");
        return false;
    }

    let quot = bool.match(/["]/g); // count double quotes [\"]
    if (quot != null && quot.length % 2 != 0) {
        toast.error("Invalid Boolean.(quotes missing)");
        return false;
    }
    let newt = bool.match(/[(]/g); // [\(]
    let newts = bool.match(/[)]/g); // [\)]
    if ((newts == null || newt == null) && newt != newts) {
        toast.error("Invalid Boolean.(braces missing)");
        return false;
    }
    if (newts != null && newt != null) {
        if (newts.length != newt.length) {
            toast.error("Invalid Boolean.(braces missing)");
            return false;
        }
    }

    if (bool.indexOf("AND") != -1) {
        let a = bool.split("AND");
        if (a.length > 0) {
            for (let i = 0; i < a.length; i++) {
                let newt = allReplace(a[i].trim());
                if (newt == "") {
                    toast.error("Invalid Boolean.(Please enter word after/before boolean operator AND)");
                    return false;
                }
            }
        }
    }

    if (bool.indexOf("OR") != -1) {
        let a = bool.split(" OR ");
        if (a.length > 0) {
            for (let i = 0; i < a.length; i++) {
                let newt = allReplace(a[i].trim());
                if (newt == "") {
                    toast.error("Invalid Boolean.(Please enter word after/before boolean operator OR)");
                    return false;
                }
            }
        }
    }

    if (bool.indexOf("NOT") != -1) {
        let a = bool.split("NOT");
        if (a.length > 0) {
            for (let i = 0; i < a.length; i++) {
                let newt = allReplace(a[i].trim());
                if (newt == "") {
                    toast.error("Invalid Boolean.(Please enter word after/before boolean operator NOT)");
                    return false;
                }
            }
        }
    }

    if (bool.indexOf("+") != -1) {
        let a = bool.split("+");
        if (a.length > 0) {
            for (let i = 0; i < a.length; i++) {
                let newt = allReplace(a[i].trim());
                if (newt == "") {
                    toast.error("Invalid Boolean.(Please enter word after/before operator +)");
                    return false;
                }
            }
        }
    }

    if (bool.indexOf("-") != -1) {
        let a = bool.split("-");
        if (a.length > 0) {
            for (let i = 0; i < a.length; i++) {
                let newt = allReplace(a[i].trim());
                if (newt == "" && !this.props.finalQuery.startswith("handlers:")) {
                    toast.error("Invalid Boolean.(Please enter word after/before operator -)");
                    return false;
                }
            }
        }
    }
    const CheckOperator = (q, operator) => {
        var ab = q.match(operator);
        if (ab != null) {
            for (var i = 0; i < ab.length; i++) {
                var k = ab[i].trim().replace(/[A-Z]/g, "");
                if (k.length) {
                    // toast.error("Boolean operators should be in UPPERCASE");
                    return false;
                }
            }
        }
        return true;
    };
    let boolVal = bool;
    let boolV1 = boolVal.replace(/".*?"/g, ""); ///\".*?\"/
    if (!CheckOperator(boolV1, /\sand\s/gi)) {
        toast.error("Boolean operators should be in Uppercase");
        return false;
    }
    if (!CheckOperator(boolV1, /\sor\s/gi)) {
        toast.error("Boolean operators should be in Uppercase");
        return false;
    }
    if (!CheckOperator(boolV1, /\snot\s/gi)) {
        toast.error("Boolean operators should be in Uppercase");
        return false;
    }

    return true;
};
class EasyMode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedLanguge: [],
        };
        this.keywordDivEnd = React.createRef();
        this.phrasesDivEnd = React.createRef();
        this.excludeDivEnd = React.createRef();
    }
    componentDidMount() {
        this.props.getAllSupportedLanguages();
    }

    scrollKeywordToBottom = () => {
        this.keywordDivEnd.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    };
    scrollPhraseToBottom = () => {
        this.phrasesDivEnd.current?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };
    scrollExcludeToBottom = () => {
        this.excludeDivEnd.current?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };
    handleCountryChange = (selectedCountryOptions) => {
        let countryList = [];
        countryList = selectedCountryOptions.map((ele) => ele.label);
        if (countryList.includes("Worldwide")) {
            this.props.setLocation([selectedCountryOptions[selectedCountryOptions.length - 1]]);
        } else {
            this.props.setLocation(selectedCountryOptions);
        }
        this.props.setCheckIsDirty(true);
    };

    handleKeyWordChange = (e, i) => {
        let querylength;
        if (!this.props.fetchNewData) {
            // querylength = 5000;
            querylength = this.props.packageObj.package_code === "free" ? 1024 : 5000;
        } else {
            let countryFilter = "";

            this.props.selectedCountryOptions?.forEach((country) => {
                if (country.gnip_filters?.length > countryFilter.length) countryFilter = country.gnip_filters;
            });

            if (countryFilter.length > 0) querylength = 2048 - (countryFilter.length + 4);
            else querylength = 2048;

            if (querylength > 1024) querylength = 1024;
            if (querylength < 0) querylength = 0;
        }
        if (this.props.finalQuery.length <= querylength) {
            const keywordList = [...this.props.keywords];
            keywordList[i]["keyword"] = e.target.value;
            if (keywordList[i]["translatedText"] !== "") {
                keywordList[i]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
            }
            this.props.setKeywordTypeValue([...keywordList], "keywords");
            this.resultantQuery();
        } else {
            // const keywordList = [...this.props.keywords];
            // keywordList[i]["keyword"] = ev.target.value.substring(0, querylength);
            // if (keywordList[i]["translatedText"] !== "") {
            //     keywordList[i]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
            // }
            // this.props.setKeywordTypeValue([...keywordList], "keywords");
            // this.resultantQuery();
            toast.error("Query length is exceeding specified character limit");
        }
        this.props.setCheckIsDirty(true);
    };
    handleGenericChange = (ev, i) => {
        let querylength;
        if (!this.props.fetchNewData) {
            // querylength = 5000;
            querylength = this.props.packageObj.package_code === "free" ? 1024 : 5000;
        } else {
            let countryFilter = "";

            this.props.selectedCountryOptions?.forEach((country) => {
                if (country.gnip_filters?.length > countryFilter.length) countryFilter = country.gnip_filters;
            });

            if (countryFilter.length > 0) querylength = 2048 - (countryFilter.length + 4);
            else querylength = 2048;

            if (querylength > 1024) querylength = 1024;
            if (querylength < 0) querylength = 0;
        }
        if (this.props.finalQuery.length < querylength) {
            const genericList = [...this.props.genericKeyword];
            genericList[i]["keyword"] = ev.target.value;
            if (genericList[i]["translatedText"] !== "") {
                genericList[i]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
            }
            this.props.setKeywordTypeValue([...genericList], "genericKeyword");
            this.resultantQuery();
        } else {
            // const genericList = [...this.props.genericKeyword];
            // genericList[i]["keyword"] = ev.target.value.substring(0, querylength);
            // if (genericList[i]["translatedText"] !== "") {
            //     genericList[i]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
            // }
            // this.props.setKeywordTypeValue([...genericList], "genericKeyword");
            // this.resultantQuery();
            toast.error("Query length is exceeding specified character limit");
        }
        this.props.setCheckIsDirty(true);
    };
    handleExcludedKeyWord = (ev, i) => {
        let querylength;
        if (!this.props.fetchNewData) {
            // querylength = 5000;
            querylength = this.props.packageObj.package_code === "free" ? 1024 : 5000;
        } else {
            let countryFilter = "";

            this.props.selectedCountryOptions?.forEach((country) => {
                if (country.gnip_filters?.length > countryFilter.length) countryFilter = country.gnip_filters;
            });

            if (countryFilter.length > 0) querylength = 2048 - (countryFilter.length + 4);
            else querylength = 2048;

            if (querylength > 1024) querylength = 1024;
            if (querylength < 0) querylength = 0;
        }
        if (this.props.finalQuery.length < querylength) {
            const excludedList = [...this.props.excludedKeyword];
            excludedList[i]["keyword"] = ev.target.value;
            if (excludedList[i]["translatedText"] !== "") {
                excludedList[i]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
            }
            this.props.setKeywordTypeValue([...excludedList], "excludedKeyword");
            this.resultantQuery();
        } else {
            // const excludedList = [...this.props.excludedKeyword];
            // excludedList[i]["keyword"] = ev.target.value.substring(0, querylength);
            // if (excludedList[i]["translatedText"] !== "") {
            //     excludedList[i]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
            // }
            // this.props.setKeywordTypeValue([...excludedList], "excludedKeyword");
            // this.resultantQuery();

            toast.error("Query length is exceeding specified character limit");
        }
    };

    resultantQuery = () => {
        let keywords = this.props.keywords;
        let genericKeyword = this.props.genericKeyword;
        let excludedKeyword = this.props.excludedKeyword;
        let keywordQuery = handleQueryBuilder(keywords);
        let genericQuery = handleQueryBuilder(genericKeyword);
        let excludedQuery = handleQueryBuilder(excludedKeyword);
        let combinedQuery = "";
        combinedQuery = combinedQuery.concat(keywordQuery);
        if (keywordQuery.length > 0) combinedQuery = " (" + combinedQuery + ") ";
        if (genericQuery.length > 0) {
            combinedQuery = combinedQuery.concat("\n");
            combinedQuery = combinedQuery.concat(" AND " + " (" + genericQuery + ") ");
        }
        if (excludedQuery.length > 0) {
            combinedQuery = combinedQuery.concat("\n");
            combinedQuery = combinedQuery.concat(" AND NOT " + " (" + excludedQuery + ") ");
        }

        this.props.setBoolean(combinedQuery);
        if (this.props.showSampleButtonState && this.props.showSampleData) {
            this.props.toggleSampleButton();
        }
    };
    clearKeyword = (ind, keywordType) => {
        const keywordList = [...this.props[keywordType]];
        keywordList[ind]["keyword"] = "";
        keywordList[ind]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
        this.props.setKeywordTypeValue([...keywordList], keywordType);
        this.resultantQuery();
    };

    showSamplePosts = () => {
        const query = this.props.finalQuery;
        if (query === "") {
            toast.error("Please add your boolean query");
            return;
        }
        if (!validateBooleans(query)) {
            return false;
        }
        let selectedCountries = this.props.selectedCountryOptions;
        if (selectedCountries.length === 0) {
            toast.error("Please select a Location");
            return;
        }
        if (!Array.isArray(selectedCountries)) {
            selectedCountries = [selectedCountries];
        }
        let countries = selectedCountries.map((ele) => {
            if (ele.label === "Worldwide") {
                return "";
            } else return ele.value;
        });
        const params = {};
        this.props.packageObj.package_code == "free" ? (params["countries"] = "") : (params["countries"] = countries.join(","));
        params["query"] = query.replaceAll("\n", "");
        //.replaceAll('"', "")
        this.props.searchQueryResults(params);
        if (!this.props.showSampleData) {
            this.props.setShowSample(true);
        }
        this.props.toggleSampleButton();
    };
    toggleShowSampleData = () => {
        this.props.setShowSample(!this.props.showSampleData);
    };
    characterLeftForBoolean = () => {
        let total;
        if (!this.props.fetchNewData) {
            total = this.props.packageObj.package_code === "free" ? 1024 : 5000;
        } else {
            let countryFilter = "";

            this.props.selectedCountryOptions?.forEach((country) => {
                if (country.gnip_filters?.length > countryFilter.length) countryFilter = country.gnip_filters;
            });

            if (countryFilter.length > 0) total = 2048 - (countryFilter.length + 4);
            else total = 2048;

            if (total > 1024) total = 1024;
        }

        let charactersLeft = total - this.props.finalQuery.length;
        if (charactersLeft < 0) return 0;
        return charactersLeft;
    };
    customStyle = {
        control: (base) => ({ ...base, border: 0, height: "30px", minHeight: "30px", top: "20%", boxShadow: "none", background: "#F7F7F7", color: "#1F2E3D" }),
        option: (styles, { isSelected }) => {
            return { ...styles, backgroundColor: isSelected ? "#F7F7F7" : null, color: "#1F2E3D" };
        },
        singleValue: (provided) => {
            return { ...provided, color: "#1F2E3D" };
        },
        dropdownIndicator: (base) => ({
            ...base,
            color: "#697384",
            padding: "4px",
        }),
        clearIndicator: (base) => ({
            ...base,
            color: "#697384",
            padding: "4px",
        }),
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#8093b2",
            };
        },
    };
    handleLanguageChange = (selectedLanguge, ind, keyWordType, point) => {
        const keywordList = [...this.props[keyWordType]];
        keywordList[ind]["translateOptionsList"][point]["selectedLanguage"] = selectedLanguge;
        this.props.setKeywordTypeValue([...keywordList], keyWordType);
        //translate code
        const textToTranslate = keywordList[ind]["keyword"];
        const languageSelected = selectedLanguge;
        if (textToTranslate === "") {
            toast.error("Please add a text for translation");
            return;
        }
        if (languageSelected == null || languageSelected.length === 0) {
            toast.error("Please select a language for translation");
            return;
        }
        let params = {};
        const content = [];
        content.push(textToTranslate);
        params["content"] = content;
        params["langCode"] = languageSelected.value;
        this.props
            .googleTextTranslate(params)
            .then((res) => {
                keywordList[ind]["translateOptionsList"][point]["translatedText"] = res.value.data[0][0];
                this.props.setKeywordTypeValue([...keywordList], keyWordType);
            })
            .catch((err) => {});
        this.props.setCheckIsDirty(true);
    };

    addTranslatedText = (ind, keyWordType, point) => {
        let keywordList = [...this.props[keyWordType]];
        if (
            keywordList[ind]["translateOptionsList"][point]["selectedLanguage"] === null ||
            keywordList[ind]["translateOptionsList"][point]["selectedLanguage"].length === 0
        ) {
            toast.error("Please select a language to translate your text");
            return;
        }
        keywordList[ind]["translateOptionsList"][point]["addedText"] = keywordList[ind]["translateOptionsList"][point]["translatedText"];
        this.props.setKeywordTypeValue([...keywordList], keyWordType);
        this.resultantQuery();
    };

    enableTranslateBlock = (ind, keyWordType) => {
        const keywordList = [...this.props[keyWordType]];
        let newList = [];
        if (keywordList[ind]["keyword"].length > 0) {
            if (keywordList[ind]["enable"] && keywordList[ind]["translateOptionsList"].length > 1) {
                newList = keywordList[ind]["translateOptionsList"].filter((ele, ind) => {
                    if ((ele.selectedLanguage !== null || ele.selectedLanguage?.length !== 0) && ele.translatedText !== "") {
                        return ele;
                    }
                });
                keywordList[ind]["translateOptionsList"] = newList;

                if (newList.length === 0) {
                    keywordList[ind]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
                }
            }
            keywordList[ind]["enable"] = !keywordList[ind]["enable"];
            this.props.setKeywordTypeValue([...keywordList], keyWordType);
        }
    };
    removeTranslate = (ind, keyWordType, point) => {
        const keywordList = [...this.props[keyWordType]];
        if (keywordList[ind]["translateOptionsList"][point]["translatedText"] !== "") {
            keywordList[ind]["translateOptionsList"][point]["translatedText"] = "";
            keywordList[ind]["translateOptionsList"][point]["selectedLanguage"] = [];
            keywordList[ind]["translateOptionsList"][point]["addedText"] = "";
            this.props.setKeywordTypeValue([...keywordList], keyWordType);
            this.resultantQuery();
        } else {
            return false;
        }
    };
    increaseTranslate = (ind, keyWordType, elem) => {
        const keywordList = [...this.props[keyWordType]];
        let lastItem = keywordList[ind].translateOptionsList[keywordList[ind].translateOptionsList.length - 1];
        if (lastItem.selectedLanguage === null || lastItem.selectedLanguage.length === 0) {
            return;
        }
        keywordList[ind].translateOptionsList.push({ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }),
            this.props.setKeywordTypeValue([...keywordList], keyWordType);

        if (keyWordType === "keywords") setTimeout(() => this.scrollKeywordToBottom(), 0);
        if (keyWordType === "genericKeyword") setTimeout(() => this.scrollPhraseToBottom(), 0);
        if (keyWordType === "excludedKeyword") setTimeout(() => this.scrollExcludeToBottom(), 0);
    };
    handleKeyPress = (e, keyWordType) => {
        if (e.charCode === 13 && e.target.value !== "") {
            if (keyWordType === "keywords") {
                addKeywordsField(this.props.keywords, this.props.setKeywordTypeValue);
            } else if (keyWordType === "genericKeyword") {
                addGenericField(this.props.genericKeyword, this.props.setKeywordTypeValue);
            } else if (keyWordType === "excludedKeyword") {
                addExcludedField(this.props.excludedKeyword, this.props.setKeywordTypeValue);
            }
        }
    };

    render() {
        let isSampleDataBlockOpened = this.props.showSampleData;

        return (
            <div className="easyMode">
                {/* <Scrollbars autoHide> */}
                <div className={`easyMode__left-block `}>
                    <div className="keyword__configuration-block">
                        <p className="expand__block">
                            <div className="expand__header qb_step6">
                                <span className="open__icon">
                                    {!this.props.expandKeywordBlock ? (
                                        <ExpandViewIcon
                                            onClick={() => {
                                                this.props.setKeywordExpandBlock(true);
                                                if (this.props.interactive_help_enabled) this.props.setAccountExpandBlock(false);
                                            }}
                                        />
                                    ) : (
                                        <CollapseViewIcon onClick={() => this.props.setKeywordExpandBlock(false)} />
                                    )}
                                </span>
                                <p className="view__label">Configure Keywords</p>
                                <span className="verified__icon">{this.props.finalQuery.length > 6 && <ProgressIcon />}</span>
                            </div>
                        </p>
                        <ConfigureKeywords
                            expandKeywordBlock={this.props.expandKeywordBlock}
                            selectedCountryOptions={this.props.selectedCountryOptions}
                            handleCountryChange={this.handleCountryChange}
                            disableLocationTab={false}
                            keywords={this.props.keywords}
                            addKeywordsField={addKeywordsField}
                            handleKeyWordChange={this.handleKeyWordChange}
                            handleKeyPress={this.handleKeyPress}
                            clearKeyword={this.clearKeyword}
                            enableTranslateBlock={this.enableTranslateBlock}
                            langOptionsCalculations={langOptionsCalculations}
                            handleLanguageChange={this.handleLanguageChange}
                            // customStyle={this.customStyle}
                            increaseTranslate={this.increaseTranslate}
                            addTranslatedText={this.addTranslatedText}
                            removeTranslate={this.removeTranslate}
                            keywordDivEnd={this.keywordDivEnd}
                            genericKeyword={this.props.genericKeyword}
                            addGenericField={addGenericField}
                            handleGenericChange={this.handleGenericChange}
                            excludedKeyword={this.props.excludedKeyword}
                            toggleShowSampleData={this.toggleShowSampleData}
                            phrasesDivEnd={this.phrasesDivEnd}
                            excludeDivEnd={this.excludeDivEnd}
                            showSampleButtonState={this.props.showSampleButtonState}
                            showSamplePosts={this.showSamplePosts}
                            rawData={this.props.queryResults?.hits}
                            queryResultsLoading={this.props.queryResultsLoading}
                            queryResults={this.props.queryResults}
                            finalQuery={this.props.finalQuery}
                            characterLeftForBoolean={this.characterLeftForBoolean}
                            isSampleDataBlockOpened={isSampleDataBlockOpened}
                            fetchNewData={this.props.fetchNewData}
                            addExcludedField={addExcludedField}
                            handleExcludedKeyWord={this.handleExcludedKeyWord}
                        />
                    </div>
                    <AddAccount
                        booleanValue={this.props.finalQuery}
                        selectedCountryOptions={this.props.selectedCountryOptions}
                        setCheckIsDirty={this.props.setCheckIsDirty}
                    />
                </div>
                {/* </Scrollbars> */}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        queryResultsLoading: state.queryBuilderReducer.queryResultsLoading,
        queryResults: state.queryBuilderReducer.queryResults,
        platformWiseData: state.queryBuilderReducer.platformWiseData,
        defaultCountries: state.globalReducer.company.default_country,
        // allSupportedLanguages: state.queryBuilderReducer.allSupportedLanguages,
        allLocations: state.filterSettingReducer.masterLocations,
        selectedCountryOptions: state.queryBuilderReducer.selectedCountryOptions,
        finalQuery: state.queryBuilderReducer.finalQuery,
        fetchNewData: state.queryBuilderReducer.fetchNewData,
        keywords: state.queryBuilderReducer.keywords,
        genericKeyword: state.queryBuilderReducer.genericKeyword,
        excludedKeyword: state.queryBuilderReducer.excludedKeyword,
        showSampleData: state.queryBuilderReducer.showSampleData,
        expandKeywordBlock: state.queryBuilderReducer.expandKeywordBlock,
        expandAccountBlock: state.queryBuilderReducer.expandAccountBlock,
        showSampleButtonState: state.queryBuilderReducer.showSampleButtonState,
        interactive_help_enabled: state.globalReducer.interactive_help_enabled,
        packageObj: state.globalReducer.packageObj,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        searchQueryResults: (data) => dispatch(searchQueryResults(data)),
        fetchProgressBarInfo: (data) => dispatch(fetchProgressBarInfo(data)),
        resetPostContainer: () => dispatch(resetPostContainer()),
        getAllSupportedLanguages: () => dispatch(getAllSupportedLanguages()),
        googleTextTranslate: (data) => dispatch(googleTextTranslate(data)),
        setLocation: (data) => dispatch(setLocation(data)),
        setBoolean: (data) => dispatch(setBoolean(data)),
        setKeywordTypeValue: (values, type) => dispatch(setKeywordTypeValue(values, type)),
        setShowSample: (value) => dispatch(setShowSample(value)),
        setAccountExpandBlock: (value) => dispatch(setAccountExpandBlock(value)),
        setKeywordExpandBlock: (value) => dispatch(setKeywordExpandBlock(value)),
        setValidRule: (data) => dispatch(setValidRule(data)),
        toggleSampleButton: () => dispatch(toggleSampleButton()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(EasyMode);
